export default "__VITE_ASSET__3AbdWWgtbrvJIojXBl8n$Q__"